/**
 * Maatcheck op de productpagina: lengte van het kind vergelijken met het
 * lengtebereik van dit product (metafield specs.lichaamslengte, met de
 * wielmaat als terugval). Vlak buiten het bereik (4 cm eronder, 3 cm erboven)
 * geven we mild advies; daarbuiten adviseren we stellig de maat die wél past
 * via de vaste maatladder (gelijk aan maatgids en maathulp).
 */

// Zelfde banden als de maathulp/maatgids; links naar de wielmaat-collecties
const MAATLADDER = [
  { min: 75, max: 94, label: 'loopfiets', url: '/collections/loopfietsen' },
  { min: 95, max: 104, label: '12 inch', url: '/collections/12-inch' },
  { min: 105, max: 119, label: '14 of 16 inch', url: '/collections/16-inch' },
  { min: 120, max: 134, label: '18 of 20 inch', url: '/collections/20-inch' },
  { min: 135, max: 149, label: '22 of 24 inch', url: '/collections/24-inch' },
  { min: 150, max: 170, label: '26 inch', url: '/collections/26-inch' },
];

// Wielmaat -> maatladder-rij, als het product geen lengte-metafield heeft
const WIELMAAT_RIJ = { 12: 1, 14: 2, 16: 2, 18: 3, 20: 3, 22: 4, 24: 4, 26: 5 };

function productBereik(kaart) {
  const lengte = kaart.dataset.lengte || '';
  const match = lengte.match(/(\d+)\D+(\d+)/);
  if (match) return { min: Number(match[1]), max: Number(match[2]) };

  const rij = WIELMAAT_RIJ[Number(kaart.dataset.wielmaat)];
  if (rij !== undefined) return { min: MAATLADDER[rij].min, max: MAATLADDER[rij].max };
  return null;
}

function ladderRij(cm) {
  if (cm < MAATLADDER[0].min) return MAATLADDER[0];
  if (cm > MAATLADDER[MAATLADDER.length - 1].max) return MAATLADDER[MAATLADDER.length - 1];
  // Afronden: decimalen (134,5) vallen anders precies tussen twee banden in
  const afgerond = Math.round(cm);
  return MAATLADDER.find((rij) => afgerond >= rij.min && afgerond <= rij.max) ?? MAATLADDER[0];
}

// Boven deze lengte bestaat er geen grotere kindermaat meer
const GROOTSTE_KINDERMAAT = MAATLADDER[MAATLADDER.length - 1].max;

document.querySelectorAll('[data-maatkaart]').forEach((kaart) => {
  const input = kaart.querySelector('[data-maatcheck-input]');
  const knop = kaart.querySelector('[data-maatcheck-knop]');
  const resultaat = kaart.querySelector('[data-maatcheck-resultaat]');
  const tekst = kaart.querySelector('[data-maatcheck-tekst]');
  const link = kaart.querySelector('[data-maatcheck-link]');
  const bereik = productBereik(kaart);
  if (!input || !knop || !resultaat || !bereik) return;

  const toon = (boodschap, toestand, adviesRij) => {
    tekst.textContent = boodschap;
    resultaat.classList.toggle('is-passend', toestand === 'past');
    resultaat.classList.toggle('is-anders', toestand !== 'past');
    if (adviesRij) {
      link.href = adviesRij.url;
      link.textContent = kaart.dataset.fitLink;
      link.hidden = false;
    } else {
      link.hidden = true;
    }
    resultaat.hidden = false;
  };

  const check = () => {
    // Komma als decimaalteken accepteren (134,5) en met komma terugtonen
    const cm = parseFloat(input.value.replace(',', '.'));
    const cmTekst = String(cm).replace('.', ',');
    if (Number.isNaN(cm) || cm < 70 || cm > 180) {
      toon(kaart.dataset.fitUnknown, 'onbekend', null);
      return;
    }
    if (cm >= bereik.min && cm <= bereik.max) {
      // Binnen bereik, maar vlak onder de max: eerlijk zijn over groei
      const sjabloon = cm >= bereik.max - 2 ? kaart.dataset.fitOkTop : kaart.dataset.fitOk;
      toon(sjabloon.replace('[cm]', cmTekst), 'past', null);
      return;
    }
    if (cm < bereik.min) {
      // Tot 4 cm onder het bereik groeit het kind er binnen een paar maanden in
      if (bereik.min - cm <= 4) {
        toon(kaart.dataset.fitSmall.replace('[cm]', cmTekst), 'anders', null);
        return;
      }
      const rij = ladderRij(cm);
      toon(kaart.dataset.fitWayBig.replace('[cm]', cmTekst).replace('[maat]', rij.label), 'anders', rij);
      return;
    }
    // Boven het bereik: 3 cm speling (zadel kan nog iets omhoog), daarna is
    // de fiets echt te klein
    if (cm - bereik.max <= 3) {
      toon(kaart.dataset.fitLarge.replace('[cm]', cmTekst), 'anders', null);
      return;
    }
    if (bereik.max >= GROOTSTE_KINDERMAAT) {
      toon(kaart.dataset.fitAdult.replace('[cm]', cmTekst), 'anders', null);
      return;
    }
    const rij = ladderRij(cm);
    toon(kaart.dataset.fitWaySmall.replace('[cm]', cmTekst).replace('[maat]', rij.label), 'anders', rij);
  };

  knop.addEventListener('click', check);
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      check();
    }
  });
});
